import BlankView from '@/components/BlankView.vue'
const summaryManagement = [
      {
        path: 'summaryManagement',
        name: '汇总管理',
        component: BlankView,
        children:[
           //司机领款汇总管理
          {
            path: 'driverCollectionManagement',
            name: 'driverCollectionManagement',
            component: () => import('@/views/summaryManagement/driverCollectionManagement.vue'),
          },
          //费用报销汇总管理
          {
            path: 'expenseReimbursementManagement',
            name: 'expenseReimbursementManagement',
            component: () => import('@/views/summaryManagement/expenseReimbursementManagement.vue'),
          },
          //运输汇总管理
          {
            path: 'transportManagement',
            name: 'transportManagement',
            component: () => import('@/views/summaryManagement/transportManagement.vue'),
          },
          //鑫诚进销存汇总管理
          {
            path: 'purchaseSalesInManagement',
            name: 'purchaseSalesInManagement',
            component: () => import('@/views/summaryManagement/purchaseSalesInManagement.vue'),
          },
             //运输汇总管理
          {
              path: 'oilStorageManagement',
              name: 'oilStorageManagement',
              component: () => import('@/views/summaryManagement/oilStorageManagement.vue'),
          },
            //鑫诚进销存汇总管理
          {
              path: 'accountReceivableManagement',
              name: 'accountReceivableManagement',
              component: () => import('@/views/summaryManagement/accountReceivableManagement.vue'),
          }
        ]
      }
    
];


export default summaryManagement;